import { Injectable, Injector } from "@angular/core";
import { BaseApi } from "@services/api/base.api";
import { Observable } from "rxjs";

@Injectable()
export class ObituaryApi extends BaseApi {
	constructor( injector: Injector ) { super(injector); }

	public getDeaths(): Observable<any> {
		return this.get(this.url("/deaths")).pipe(this.defaultMap);
	}

	public getDeathsByYear(year:number): Observable<any> {
		return this.get(this.url("/deaths/:year").params({ year })).pipe(this.defaultMap);
	}

	public getDead(deadId: number|string): Observable<any> {
		return this.get(this.url("/death/:id").params({ id: deadId })).pipe(this.defaultMap);
	}

}
